import React from 'react';
import { useSelector } from 'react-redux';
import LazyImage from '../../common/lazyLoad';
const DiscountDetails = ({ item }) => {
  const logo = useSelector((state) => state.restSetting?.Setting?.logo);
  const { text1, text2, text3, text4, template } = item;
  const properties = template?.properties;
  const text1Property = {
    align: properties?.text1['color'],
    color: properties?.text1['color'],
    fontSize: properties?.text1['font-size'],
    fontWeight: properties?.text1['font-weight'],
  };
  const text2Property = {
    align: properties?.text2['color'],
    color: properties?.text2['color'],
    fontSize: properties?.text2['font-size'],
    fontWeight: properties?.text2['font-weight'],
  };
  const text3Property = {
    align: properties?.text3['color'],
    color: properties?.text3['color'],
    fontSize: properties?.text3['font-size'],
    fontWeight: properties?.text3['font-weight'],
  };
  const text4Property = {
    align: properties?.text4['color'],
    color: properties?.text4['color'],
    fontSize: properties?.text4['font-size'],
    fontWeight: properties?.text4['font-weight'],
  };
  return (
    <div className='text-center p-3'>
      {template?.type == 2 && (
        <LazyImage width='40%' src={logo} className='promotion_logo' alt='logo' />
      )}
      <p style={text1Property} className='p-0 m-0 '>
        {text1}
      </p>
      <h1 style={text2Property} className='p-0 m-0 '>
        {text2}
      </h1>
      <p style={text3Property} className='p-0 m-0 '>
        {text3}
      </p>
      <p style={text4Property} className='p-0 m-0'>
        {text4}
      </p>
    </div>
  );
};

export default DiscountDetails;
